import PropTypes from 'prop-types';
import { Filters } from '@domain-group/fe-allhomes-search-api';
export default PropTypes.instanceOf(Filters);